import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { authService } from '../services/auth';
import { useTranslation } from 'react-i18next';

const Navbar: React.FC = () => {
  const navigate = useNavigate();
  const user = authService.getCurrentUser();
  const isAuthenticated = authService.isAuthenticated();
  const { t, i18n } = useTranslation();
  const [menuOpen, setMenuOpen] = useState(false);

  const handleLogout = async () => {
    await authService.logout();
    navigate('/');
  };

  // Lock body scroll when mobile menu is open
  useEffect(() => {
    if (menuOpen) {
      document.body.classList.add('no-scroll');
    } else {
      document.body.classList.remove('no-scroll');
    }
    return () => {
      document.body.classList.remove('no-scroll');
    };
  }, [menuOpen]);

  return (
    <nav className="navbar">
      <div className="nav-container">
        <Link to="/" className="nav-logo">
          <img 
            src="/logo.png" 
            alt={t('app.name')} 
            style={{
                  
              height: '100px',  
              width: 'auto',
              objectFit: 'contain',
              background: 'white',
              padding: '0px',
              borderRadius: '50px',
              boxShadow: 'rgba(0, 0, 0, 0.15) 0px 2px 6px',
            }}
          />
          {/* <span className="logo-text">{t('app.name')}</span> */}
        </Link>
        
        <button
          className="nav-toggle"
          aria-label="Toggle navigation"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </button>

        <div className={`nav-menu ${menuOpen ? 'open' : ''}`}>
          {!isAuthenticated ? (
            <>
              <Link to="/" className="nav-link">{t('nav.home')}</Link>
              <Link to="/notices" className="nav-link">{t('nav.notices')}</Link>
              <Link to="/videos" className="nav-link">{t('nav.videoGallery')}</Link>
              <Link to="/galleries" className="nav-link">{t('nav.imageGallery')}</Link>
              <Link to="/login" className="nav-link">{t('nav.login')}</Link>
              <Link to="/register" className="nav-link">{t('nav.register')}</Link>
            </>
          ) : (
            <>
              <Link to="/notices" className="nav-link">{t('nav.notices')}</Link>
              <Link to="/videos" className="nav-link">{t('nav.videoGallery')}</Link>
              <Link to="/galleries" className="nav-link">{t('nav.imageGallery')}</Link>
              <Link to="/dashboard" className="nav-link">{t('nav.dashboard')}</Link>
              {['manager', 'building_committee'].includes(user?.role || '') && (
                <Link to="/manager" className="nav-link">{t('nav.managerPanel')}</Link>
              )}
              {['admin', 'central_committee'].includes(user?.role || '') && (
                <Link to="/admin" className="nav-link">{t('nav.adminPanel')}</Link>
              )}
              <Link to="/profile" className="nav-link">
                <i className="fas fa-user mr-2"></i>{t('nav.profile')}
              </Link>
              <button onClick={handleLogout} className="nav-link logout-btn">
                {t('nav.logout')}
              </button>
            </>
          )}
          <div className="nav-language">
            <label htmlFor="language-select">{t('language.switchLabel')}</label>
            <select
              id="language-select"
              value={i18n.language || 'en'}
              onChange={(event) => i18n.changeLanguage(event.target.value)}
            >
              <option value="en">{t('language.english')}</option>
              <option value="bn">{t('language.bangla')}</option>
            </select>
          </div>
        </div>
      </div>
      {/* Backdrop for mobile menu */}
      <div
        className={`nav-backdrop ${menuOpen ? 'show' : ''}`}
        onClick={() => setMenuOpen(false)}
      />
    </nav>
  );
};

export default Navbar;
